import { createContext, useContext, type ReactNode } from 'react';
import { useApp } from './app';
import { useLiveRide } from './live';

type RideCtx = ReturnType<typeof useLiveRide>;
const Ctx = createContext<RideCtx | null>(null);

/** One live-ride subscription for the whole app (socket + polling), shared by every screen. */
export function RideProvider({ children }: { children: ReactNode }) {
  const { api, signedIn } = useApp();
  const live = useLiveRide(api, signedIn);
  return <Ctx.Provider value={live}>{children}</Ctx.Provider>;
}

export function useRide(): RideCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error('useRide outside RideProvider');
  return c;
}

/** Connection state for banners; null outside the provider (component tests). */
export const useConnection = () => {
  const c = useContext(Ctx);
  return c ? { offline: c.offline, connected: c.connected, liveRide: c.ride, retry: c.refetch } : null;
};
